

'use strict';

if (window.jQuery) var $ = window.jQuery;

$(function () {
  aweHosoren.init();

  //== DEMO ONLY
  aweSearchMenubar();
  
});

function aweMaps(mapElement) {
  if (! mapElement) {
    mapElement = '#contact-map';
  }

  var map = new GMaps({
    el: mapElement,
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),

    draggable: true,
    scrollwheel: false
  });

  map.addMarker({
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),
  });
}

// ===

function aweSearchMenubar() {
  var $navbar = $('.awemenu-nav');

  var $searchForm = $('#menubar-search-form');
  var $openSearch = $('#open-search-form .icon-search');
  var $closeSearch = $('#close-search-form');

  $openSearch.on('click', function(e) {
    e.preventDefault();
    $searchForm.addClass('open');

    setTimeout(function() {
      $searchForm.find('input').focus();
    }, 250);
  });

  $closeSearch.on('click', function(e) {
    e.preventDefault();
    $searchForm.removeClass('open');
  });


  $(window).resize(function() {
    if ($navbar.hasClass('awemenu-mobile')) {
      $searchForm.width('100%');
      $searchForm.css({right: '0'});
    } else {
      var $awemenu = $('.awemenu-nav .awemenu');
      var $aweicon = $('.awemenu-nav .navbar-icons');

      var width = $awemenu.width() + 50;
      var offsetRight = $aweicon.width() + 20;

      $searchForm.width(width);
      $searchForm.css({right: offsetRight});
    }
  }).trigger('resize');

}

$(document).click(function (e){
  var container = $("#menubar-search-form");
  var container2=$("#open-search-form");
  if (!container.is(e.target) && !container2.is(e.target) && container.has(e.target).length === 0  && container2.has(e.target).length === 0){ 
    $('#menubar-search-form').removeClass('open');
  }
});


// ===
function aweMainSlider() {
  var $slider = $('.main-slider');

  $slider.owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    onInitialized: function() {
      $slider.find('.owl-item').each(function() {
        var $owlItem = $(this);

        var $mainSlide = $owlItem.find('.main-slider-item');
        var $mainImage = $owlItem.find('.main-slider-image > img');

        if ($mainSlide.length && $mainImage.length) {
          $mainSlide.addClass('background');
          $mainSlide.css('background-image', 'url('+$mainImage.attr('src')+')');

          $mainImage.css({
            opacity: 0,
            visibility: 'hidden'
          });
        }
      });
    }
  });
}

function awePriceSlider($selector) {
  if (! $selector) {
    $selector = $('#price-slider');
  }

  $selector.slider({
    values: [35, 250],
    min: 10,
    max: 320,
    step: 10,
    range: true,
    slide: function(e, ui) {
      $('#amount').text('$'+ui.value);
    }
  });
}

function aweBlogMasonry($selector) {
  if (! $selector) {
    $selector = $('.blog-masonry .row-masonry');
  }

  $selector.imagesLoaded(function() {
    $selector.masonry({
      itemSelector: '.column',
      columnWidth: '.column'
    });
  });
}

function aweProfolioIsotope($selector) {
  if (! $selector) {
    $selector = $('.grid');
  }

  $selector.imagesLoaded(function() {
    var $grid = $selector.isotope({
      itemSelector: '.grid-item',
      layoutMode: 'masonry'
    });
  });

  $('.awe-nav').on('click', 'a', function(e) {
    e.preventDefault();

    $(this).parents('.awe-nav').find('li').removeClass('active');
    $(this).closest('li').addClass('active');

    var filter = $(this).attr('data-filter');
    $selector.isotope({ filter: filter });
  });
}

function aweProfolioDetail() {
  $('.lasted-portfolio-carousel').owlCarousel({
    items: 4,
    nav: true,
    dots: false,
    margin: 30,
    responsive: {
      0: { items: 1 },
      480: { items: 2 },
      768: { items: 3 },
      980: { items: 4 }
    }
  });

  $('.image').magnificPopup({
    type: 'image',
    delegate: 'a',
    gallery: { enabled: true }
  });
}

function aweProductSidebar() {
  var $filterSidebar = $('#shop-widgets-filters');
  var $toggleButton = $('#open-filters');

  var $overlay = $('body').find('.widgets-filter-overlay');

  function _open() {
    $filterSidebar.addClass('open');

    if (! $overlay.length) {
      $('body').append('<div class="widgets-filter-overlay"></div>');
    }

    $('body').addClass('open-filters-open');
  }

  function _close() {
    $filterSidebar.removeClass('open');
    $(document).find('.widgets-filter-overlay').remove();
    $('body').removeClass('open-filters-open');
  }

  $toggleButton.on('click', function() {
    if (! $filterSidebar.hasClass('open')) {
      _open();
    } else {
      _close();
    }
  });

  $('body').on('click', '.widgets-filter-overlay', function() {
    _close();
  });
}

function aweProductRender(thumbHorizontal) {
  if (Modernizr && ! Modernizr.touch) {
    $('.easyzoom').easyZoom();
  }

  var sMain = new Swiper('.product-slider-main', {
    loop: false,

    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev'
  });

  var sThumb = new Swiper('.product-slider-thumbs', {
    loop: false,
    centeredSlides: true,
    spaceBetween: thumbHorizontal ? 15 : 0,
    slidesPerView: thumbHorizontal ? 4 : 3,
    direction: thumbHorizontal ? 'horizontal' : 'vertical',
    slideToClickedSlide: true
  });

  sMain.params.control = sThumb;
  sThumb.params.control = sMain;
}




var selectCallback = function(variant, selector) {
  if (variant) {
    if (variant.available) {
      // Selected a valid variant that is available.
      $('#add').removeClass('disabled').removeAttr('disabled').val('Add to Cart').fadeTo(200,1);
    } else {
      // Variant is sold out.
      $('#add').val('Sold Out').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);        
    }
    // Whether the variant is in stock or not, we can update the price and compare at price.
    if ( variant.compare_at_price > variant.price ) {
      $('#price-field').html('<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>'+'&nbsp;<s class="product-compare-price">'+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>');
    } else {
      $('#price-field').html('<span class="product-price">'+ Shopify.formatMoney(variant.price, "") + '</span>' );
    }        
  } else {
    // variant doesn't exist.
    $('#add').val('Unavailable').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
  }
}

$(".swiper-container").each( function(){
  var config = {
    spaceBetween: $(this).data('margin'),
    slidesPerView: $(this).data('items'),
    direction: $(this).data('direction'),
    paginationClickable: true,
    grabCursor: true 
  };		
  var swiper = new Swiper(this, config);

});


// ================== New lable=============
$('.product .product-inner').each(function(){

  var pubDate = $(this).data("publish-date");
  
  if (pubDate) {
    var pubDate2=pubDate.substr(0, 10);
    var todayDate = new Date();
    var time1 = Date.parse(pubDate2);
    var time2 = Date.parse(todayDate);
    var time= Math.abs(time2 - time1);
    var a= 30*24*60*60*1000;

    if(time < a){
      $('.product .product-inner .new').show();

    }
  }

});

$(document).ready(function(){
  if($(".product-body-list").children().length > 0){
  
    $('.view-mode .grid').removeClass('active');
     $('.view-mode .list').addClass('active');
  }
});

var ProductImage = function(url, is_original) {
  var self = this;
  
  this.url = url;
  this.is_original = is_original;
  
  var image_sizes =  "pico icon thumb small compact medium large grande 1024x1024 2048x2048 master original".split(" "); 
  
  function resize(size) {
    // Don't resize images that aren't from Shopify, duh!
    if (!self.url.indexOf("cdn.shopify.com") < 0) {
      return self.url;
    }

    // Set size to nothing if no size is provided
    size = size ? size : "";

    // Pick apart the url and rebuild it
    var sizes = "_" + image_sizes.join("|_");
    var filetype = "(\\.(jpg|jpeg|png|gif)+)\\?v=\\d+$";
    
    if (self.is_original) {
      var format = new RegExp(filetype, "i");
      
      return {
        original: self.url,
        resized: url.replace(format, "_"+size+"$1")
      }
    } else {
      var format = new RegExp("("+sizes+")" + filetype, "i");
       
      return {
        original: self.url.replace(format, "$2"),
        resized: self.url.replace(format, "_" + size + "$2")
      }
    }
  }

  this.original = function() {
    return resize().original;
  }

  this.resized = function(size) {
    return resize(size).resized;
  }
};

Shopify.bulkAddToCart = function(form) {
  // Bind submit event, only get enabled fields
  var $items = form.find('*[name="id"]').not(':disabled').filter(function() {
    return $(this).val() > 0;
  });
  
  if ($items.length < 1) {
    alert("Please select quantities for each product"); 
    return false;
  }
  
  var $submit_button = form.find('input[type="submit"]');
  var submit_default_text = $submit_button.val();
  $submit_button.val("Adding to cart...");
  
  var properties = form.find('.property-fields select').serialize();
  
  // Queue up the requests
  Shopify.queue = [];
  
  // For each enabled product with qty add to cart
  $items.each(function() {
    Shopify.queue.push( {
      id: $(this).attr('data-variant-id'),
      quantity: parseInt($(this).val(), 10) || 0,
      properties: properties
    });
  });
  
  // Recursivley add variants to cart that have been queued
  Shopify.bulk_add = function() {
    if (Shopify.queue.length) {
      var v = Shopify.queue.shift();
      $.ajax({
        method: 'post',
        url: '/cart/add.js',
        data: 'quantity=' + v.quantity + '&id=' + v.id + "&" + v.properties,
        dataType: 'json',
        success: Shopify.bulk_add
      });
    } else {
      window.location = "/cart";
      // $submit_button.val("✓ Added to cart");
      // 
      // $.getJSON('/cart', function(cart) {
      //   doUpdateMiniCart(cart);
      // });
      //       
      // setTimeout(function() {
      //   $submit_button.val(submit_default_text);
      // }, 3000);
    }
  }
  
  Shopify.bulk_add();
}
